import type { ThemePalette } from "./types";

export const tokyoNight: ThemePalette = {
	id: "tokyo-night",
	name: "Tokyo Night",
	family: "tokyo-night",
	appearance: "dark",

	background: "#1a1b26",
	foreground: "#a9b1d6",
	card: "#1f2335",
	cardForeground: "#a9b1d6",
	popover: "#1f2335",
	popoverForeground: "#c0caf5",

	primary: "#7aa2f7",
	primaryForeground: "#1a1b26",
	secondary: "#292e42",
	secondaryForeground: "#a9b1d6",
	muted: "#292e42",
	mutedForeground: "#565f89",
	accent: "#bb9af7",
	accentForeground: "#1a1b26",
	destructive: "#f7768e",
	destructiveForeground: "#1a1b26",

	border: "#3b4261",
	input: "#292e42",
	ring: "#7aa2f7",

	success: "#9ece6a",
	warning: "#e0af68",
	error: "#f7768e",
	info: "#7dcfff",

	chart1: "#7aa2f7",
	chart2: "#bb9af7",
	chart3: "#7dcfff",
	chart4: "#ff9e64",
	chart5: "#9ece6a",
};
